<template>
  <div>
    <jade-alert
      showIcon
      variant="positive"
      :title="$t('title')"
    >
      {{ $t('description', { acquirer: acquirer.payment_method }) }}
    </jade-alert>
  </div>
</template>

<script>
import { JadeAlert } from '@jade'
export default {
  name: 'SuccessAcquirerAffiliationAlert',

  components: {
    JadeAlert
  },

  props: {
    acquirer: {
      type: Object,
      required: true
    }
  }
}
</script>

<i18n>
{
  "pt-BR": {
    "title": "Afiliação cadastrada com sucesso!",
    "description": "Para definir a {acquirer} como sua adquirente, é necessário definir o status como ativo."
  },
  "en-US": {
    "title": "Affiliation successfully registered!",
    "description": "To set {acquirer} as your acquirer, you need to set the status to active."
  }
}
</i18n>
